import { DataGridPro } from '@mui/x-data-grid-pro'
import DataTable, { DataTableProps } from './DataTable'

export type { DataTableProps as DataTableProProps }
export type { ToolbarButton, IFilterList } from './DataTable'

const resizeSx = {
  '.MuiDataGrid-columnSeparator--sideRight': { visibility: 'hidden', display: 'block' },
  '.MuiDataGrid-columnHeader:hover .MuiDataGrid-columnSeparator--sideRight': { visibility: 'visible' },
}

const DataTablePro = (props: DataTableProps) => (
  <DataTable {...props} GridComponent={DataGridPro} extraGridSx={resizeSx} />
)

export default DataTablePro
